import { Select } from "antd"
import cls from "classnames"

import { usePhoneCountries } from "../../hooks/usePhoneCountries"

import styles from "./styles.module.less"

const CountrySelect = ({
  value,
  onChange,
  disabled,
  placeholder = "Select country",
  status,
  className
}) => {
  const { countries } = usePhoneCountries()

  const handleChange = (country_code) => {
    const picked = countries.find((c) => c.country_code === country_code)
    if (!picked) return
    onChange?.(picked)
  }

  return (
    <Select
      size={"large"}
      value={value || undefined}
      onChange={handleChange}
      className={cls(styles.select, className)}
      popupClassName={styles.dropdown}
      getPopupContainer={() => document.getElementById("main-layout") || document.body}
      showSearch
      optionLabelProp="label"
      // Options carry `searchText` (name + ISO2 lowercased) purely so this
      // filter stays a cheap substring match instead of walking the label
      // React tree.
      filterOption={(input, option) =>
        (option?.searchText || "").includes(input.trim().toLowerCase())
      }
      disabled={disabled}
      placeholder={placeholder}
      status={status}
    >
      {countries.map((c) => (
        <Select.Option
          key={c.country_code}
          value={c.country_code}
          searchText={`${c.name || ""} ${c.country_code || ""}`.toLowerCase()}
          label={
            <span className={styles.selected}>
              <span className={styles.flag}>
                <img src={c.flag} alt="" loading="lazy" />
              </span>
              <span className={styles.name}>{c.name}</span>
            </span>
          }
        >
          <div className={styles.option}>
            <span className={styles.flag}>
              <img src={c.flag} alt="" loading="lazy" />
            </span>
            <span className={styles.name}>{c.name}</span>
          </div>
        </Select.Option>
      ))}
    </Select>
  )
}

export default CountrySelect
